class ElementQuestionActionIdSelectListener extends AbstractInputListener
{

    listen()
    {

        let context = this;
        $(document).on('change', context.selector, function (){


            let current = $(this);

            let parent = current.closest('.element_column_container');

            let value = parseInt(current.val());


            let subtype_select = parent.find('.ticketavis_subtype_id');
            let label = subtype_select.closest('div').find('label');

            let subtype_wrapper = subtype_select.closest('.wrapper');

            let baggage_select = parent.find('.ticketavis_baggage_id');
            let baggage_label = baggage_select.closest('div').find('label');
            let baggage_wrapper = baggage_select.closest('.wrapper');

            if(value === 2)
            {
                baggage_wrapper.addClass('hide');
                subtype_wrapper.removeClass('hide');
            }
            else if(value === 6)
            {
                subtype_wrapper.addClass('hide');
                baggage_wrapper.removeClass('hide');
            }
            else
            {
                subtype_wrapper.addClass('hide');
                baggage_wrapper.addClass('hide');
            }




        });



        $(document).ready(function (e){
           $('.core_question_action_id').trigger('change');
        });
    }

}